import { SET_PAYMENT_METHOD, CHANGE_PAYMENT_METHOD } from 'dashboard-transactions/constants'
import * as constants from './constants'

const mergeTwoEntities = (a, b) => ({
    ...a,
    ...Object.keys(b).reduce(
        (result, key) => {
            result[key] = {
                ...(a[key] || {}),
                ...b[key],
            }

            return result
        },
        { ...a }
    ),
})

export const entities = (state = {}, action) => {
    if (action.type === constants.CLEAR_ENTITY)
        return {
            ...state,
            [action.entity]: undefined,
        }
    else if (action.result && action.entities) {
        const { entities } = action

        return Object.keys(entities).reduce(
            (mergedEntities, entity) => {
                mergedEntities[entity] = mergeTwoEntities(mergedEntities[entity] || {}, entities[entity])

                return mergedEntities
            },
            { ...state }
        )
    } else if (action.type === CHANGE_PAYMENT_METHOD) {
        return {
            ...state,
            isPaymentMethodChangedCompleted: undefined,
        }
    } else if (action.type === SET_PAYMENT_METHOD) {
        return {
            ...state,
            isPaymentMethodChangedCompleted: action.result,
            isPaymentMethodChangedError: action.error,
        }
    }
    return state
}
